import React from 'react';
import './inviteBonus.css'; // Import the CSS file for styling

const InviteBonus = ({customClassName, referralBoots}) => {
  return (
    <div className={customClassName}>
      <span className="bonus-text">{referralBoots}x Invite Bonus</span>
      <div className='triangle'/>
    </div>
  );
};

export default InviteBonus;